import React from 'react';
import './ratebar.css';

const Icon = ({ type }) => {
    const icons = {
        leaf: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20.5 3.5C12 3.5 5.5 7.5 5.5 14c0 2.5 1.5 4.5 4 4.5 4.5 0 8-4 8-8.5" />
                <path d="M4 21c2-5 5.5-8.5 11-11" />
            </svg>
        ),
        percent: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 5L5 19" />
                <circle cx="7" cy="7" r="2" />
                <circle cx="17" cy="17" r="2" />
            </svg>
        ),
        calculator: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="5" y="3" width="14" height="18" rx="2" />
                <path d="M8 7h8" />
                <path d="M8 11h2M14 11h2M8 15h2M14 15h2M8 19h2M14 19h2" />
            </svg>
        ),
        calendar: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="3" y="5" width="18" height="16" rx="2" />
                <path d="M16 3v4M8 3v4M3 10h18" />
                <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
            </svg>
        ),
        bookings: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="9" cy="8" r="3" />
                <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
                <path d="M17 5.5a3 3 0 0 1 0 5.5M18 14c1.8.7 3 2.5 3 4.5" />
            </svg>
        )
    };

    return <span className={`rate-bar-icon rate-bar-icon-${type}`}>{icons[type]}</span>;
};

const Metric = ({ icon, label, value, subText }) => (
    <div className="rate-bar-metric">
        {/* <div className="rate-bar-metric-icon">
            <Icon type={icon} />
        </div> */}

        <div className="rate-bar-metric-content">
            <div className="rate-bar-label">{label}</div>

            <div className="rate-bar-value">
                ₹ {value}
            </div>

            {subText && (
                <div className="rate-bar-subtext">
                    {subText}
                </div>
            )}
        </div>
    </div>
);

const RateBar = ({ rateDetails }) => {
    const totalTax = Number(rateDetails?.totalTax || 0);

    const cgst = (totalTax / 2).toFixed(2);
    const sgst = (totalTax / 2).toFixed(2);

    return (
        <div className="rate-bar">
            <div className="rate-bar-inner">

                {/* Green Fee */}
                <div className="rate-bar-green-fee">
                    {/* <div className="rate-bar-green-icon">
                        <Icon type="leaf" />
                    </div> */}

                    <div>
                        <div className="rate-bar-primary-label">
                            Total Green Fee
                        </div>

                        <div className="rate-bar-primary-value">
                            ₹ {rateDetails?.totalAmount ?? 0}
                        </div>

                        <div className="rate-bar-subtext">
                            incl. cart & caddy
                        </div>
                    </div>
                </div>

                {/* Tax / Amount Metrics */}
                <div className="rate-bar-metrics">

                    <Metric
                        icon="percent"
                        label="Total SGST 9%"
                        value={sgst}
                    />

                    <Metric
                        icon="percent"
                        label="Total CGST 9%"
                        value={cgst}
                    />

                    <Metric
                        icon="calculator"
                        label="Total Amount"
                        value={rateDetails?.finalAmount ?? 0}
                        subText="incl. GST"
                    />

                </div>

                {/* Date + Booking */}
                <div className="rate-bar-summary">

                    <div className="rate-bar-date">
                        {/* <div className="rate-bar-date-icon">
                            <Icon type="calendar" />
                        </div> */}

                        <div className="rate-bar-date-content">
                            <span>{rateDetails?.fromDate}</span>
                            <span>To</span>
                            <span>{rateDetails?.toDate}</span>
                        </div>
                    </div>

                    <div className="rate-bar-bookings">
                        {/* <div className="rate-bar-bookings-icon">
                            <Icon type="bookings" />
                        </div> */}

                        <div>
                            <div className="rate-bar-bookings-label">
                                {rateDetails?.type || 'Total Bookings'}
                            </div>

                            <div className="rate-bar-bookings-value">
                                {rateDetails?.total ?? 0}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default RateBar;